import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'age',
  standalone: true 
})
export class AgePipe implements PipeTransform {

  transform(dob: string | Date): string {
    if (!dob) return '';

    const birthDate = new Date(dob);
    const now = new Date();

    let years = now.getFullYear() - birthDate.getFullYear();
    let months = now.getMonth() - birthDate.getMonth();

    if (months < 0) {
      years--;
      months += 12;
    }

    return `${years}y ${months}m (${dob})`;
  }
}
